import _ from "lodash";

export const compare = (prevProps, nextProps) => {
   return _.isEqual(prevProps, nextProps);
}
